var pdp_info_rail_default = (() => {
    if (customElements.get("pdp-info-rail")) return;
    customElements.define("pdp-info-rail", class PdpInfoRail extends HTMLElement {
        connectedCallback() {
            this.mql = window.matchMedia("(min-width: 1024px)");
            this.stuck = false;
            this.onScroll = this.requestUpdate.bind(this);
            this.onMediaChange = this.update.bind(this);
            this.onLayoutChange = this.update.bind(this);
            window.addEventListener("scroll", this.onScroll, {
                passive: true
            });
            window.addEventListener("resize", this.onMediaChange);
            window.addEventListener("layout:change", this.onLayoutChange);
            this.mql.addEventListener("change", this.onMediaChange);
            this.update();
        }
        disconnectedCallback() {
            window.removeEventListener("scroll", this.onScroll);
            window.removeEventListener("resize", this.onMediaChange);
            window.removeEventListener("layout:change", this.onLayoutChange);
            this.mql?.removeEventListener("change", this.onMediaChange);
            if (this.rafId) cancelAnimationFrame(this.rafId);
        }
        requestUpdate() {
            if (this.rafId) return;
            this.rafId = requestAnimationFrame(() => {
                this.rafId = null;
                this.update();
            });
        }
        update() {
            const stuck = this.mql.matches && Math.abs(this.getBoundingClientRect().top) < 1;
            if (stuck === this.stuck) return;
            this.stuck = stuck;
            this.toggleAttribute("data-stuck", stuck);
        }
    });
})();